OE.addPlugin('Sticky', (function(){

    var Plugin = {},
        Options = {
            paddingTop : 0,
            paddingRight : 0,
            paddingBottom : 0,
            paddingLeft : 0,
            stickyClass : 'is--sticky',
            wrapperClass : 'sticky__inner',
            canBeIgnored : false,
            minwidth : 0,

            stickToBottom : false,
            usePositionFixed : true //!OE.TOUCH // position:fixed has some trashy side effects on touch devices so we won't tuse it by default
        },
        dataAttributeName = 'data-oe-sticky',
        timeoutThreshold = 2,
        elements = [];

    Plugin.init = function()
    {
        OE.$doc.addEventListener('scroll', debouncedScroll);
        window.addEventListener('resize', debouncedResize, false);
        resizeEvent();
    };

    var getOptionsFor = function(element)
    {
        return OE.Utils.getOptionsFromString(Options, element.getAttribute(dataAttributeName));
    };

    var scrollTimeout = null;
    var debouncedScroll = function()
    {
        try { window.clearTimeout(scrollTimeout); } catch(ev) { }
        scrollTimeout = window.setTimeout(scrollEvent, timeoutThreshold);
    };

    var scrollEvent = function()
    {

        var elements = getElements(),
            elementcount = elements.length,
            scroll = OE.Utils.getVisibleDocumentArea();

        if(elementcount)
        {
            for(var i = 0; i < elementcount; i++)
            {
                var element = elements[i],
                    options = getOptionsFor(element),
                    data = element['oe-sticky'];

                if(parseInt(window.innerWidth) < parseInt(options.minwidth))
                {
                    continue;
                }

                if(options.stickToBottom)
                {
                    if(data.scroll.bottom - data.add.bottom <= scroll.bottom)
                    {
                        setElementStyles(element, true);
                    }
                    else
                    {
                        setElementStyles(element, false);
                    }
                }
                else
                {
                    var invisibleArea = Math.max(0, element.offsetHeight - window.innerHeight - data.add.top + options.paddingTop),
                        offset = 0;

                    // invisibleArea+= OE.$doc.body.clientHeight - data.scroll.bottom + options.paddingBottom;

                    if(data.scroll.top - data.add.top <= scroll.top) {

                        offset = Math.min(0, OE.$doc.body.clientHeight - scroll.bottom - invisibleArea);
                        setElementStyles(element, true, offset);
                    }
                    else {
                        setElementStyles(element, false);
                    }
                }
            }
        }
    };

    var resizeTimeout = null;
    var debouncedResize = function()
    {
        try { window.clearTimeout(resizeTimeout); } catch(ev) { }
        timeout = window.setTimeout(resizeEvent, timeoutThreshold);
    };
    var resizeEvent = function() {
        resetElements();
        setElementCoordinates();
        scrollEvent();
    };

    var getElements = function()
    {
        return OE.$doc.querySelectorAll('*[' + dataAttributeName + ']');
    };

    var validateWrapper = function(element)
    {
        var options = getOptionsFor(element),
            wrapper = element.querySelector('.' + options.wrapperClass);

        if(!wrapper)
        {
            wrapper = OE.$doc.createElement('div');
            wrapper.setAttribute('class', options.wrapperClass);

            while (element.firstChild)
            {
                wrapper.appendChild(element.firstChild);
            }
            element.appendChild(wrapper);
        }

        return wrapper;
    };

    var resetElement = function(element, reset)
    {
        reset = reset === true;

        var options = getOptionsFor(element),
            wrapper = validateWrapper(element),
            p,
            defaults = {
                'style' : {
                    'element' : null,
                    'wrapper' : null
                }
            };

        element.classList.remove(options.stickyClass);

        if(reset || element['oe-sticky'] === undefined)
        {
            for(p in defaults)
            {
                defaults[p].element = element.getAttribute(p) || defaults[p].element;
                defaults[p].wrapper = wrapper.getAttribute(p) || defaults[p].wrapper;
            }

            element['oe-sticky'] = defaults;
        }
        else if(element['oe-sticky'] !== undefined)
        {
            for(p in defaults)
            {
                if(defaults[p].element === null)
                {
                    element.removeAttribute(p);
                }
                else
                {
                    element.setAttribute(p, defaults[p].element);
                }

                if(defaults[p].wrapper === null)
                {
                    wrapper.removeAttribute(p);
                }
                else
                {
                    wrapper.setAttribute(p, defaults[p].wrapper);
                }
            }
        }

        return element['oe-sticky'];
    };

    var resetElements = function()
    {
        var elements = getElements(),
            elementcount = elements.length,
            element, i, options, wrapper, rect, offset;

        if(elementcount)
        {
            for(i = 0; i < elementcount; i++)
            {
                element = elements[i];
                resetElement(element);
            }

            for(i = 0; i < elementcount; i++)
            {
                element = elements[i];
                options = getOptionsFor(element);

                if(parseInt(window.innerWidth) < parseInt(options.minwidth))
                {
                    continue;
                }

                wrapper = validateWrapper(element);
                rect = element.getBoundingClientRect();
                offset = {
                    top: rect.top + OE.Utils.getScrollPosition().top,
                    left: rect.left + OE.Utils.getScrollPosition().left
                };

                element['oe-sticky'].offset = {
                    top : offset.top,
                    left : offset.left,
                    bottom : offset.top + element.offsetHeight,
                    right : offset.left + element.offsetWidth,
                };
                element['oe-sticky'].scroll = {
                    top : element['oe-sticky'].offset.top - options.paddingTop,
                    left : element['oe-sticky'].offset.left - options.paddingLeft,
                    bottom : element['oe-sticky'].offset.bottom + options.paddingBottom,
                    right : element['oe-sticky'].offset.right + options.paddingRight
                };
                element['oe-sticky'].add = {
                    top : 0,
                    left : 0,
                    bottom: 0,
                    right : 0
                };
            }
        }
    };

    var sortElements = function(elements, type)
    {
        var elementcount = elements.length,
            tmp = [];

        if(elementcount)
        {
            for(var i = 0; i < elementcount; i++)
            {
                var options = getOptionsFor(elements[i]);
                if(!options.canBeIgnored)
                {
                    tmp.push(elements[i]);
                }

            }

            switch(type)
            {
                case 'left' :
                    elements = tmp.sort(function(a,b) {return (a['oe-sticky'].scroll.left > b['oe-sticky'].scroll.left) ? 1 : ((b['oe-sticky'].scroll.left > a['oe-sticky'].scroll.left) ? -1 : 0);} );
                    break;
                case 'bottom' :
                    elements = tmp.sort(function(a,b) {return (a['oe-sticky'].scroll.bottom < b['oe-sticky'].scroll.bottom) ? 1 : ((b['oe-sticky'].scroll.bottom < a['oe-sticky'].scroll.bottom) ? -1 : 0);} );
                    break;
                case 'right' :
                    elements = tmp.sort(function(a,b) {return (a['oe-sticky'].scroll.right < b['oe-sticky'].scroll.right) ? 1 : ((b['oe-sticky'].scroll.right < a['oe-sticky'].scroll.right) ? -1 : 0);} );
                    break;
                default :
                    elements = tmp.sort(function(a,b) {return (a['oe-sticky'].scroll.top > b['oe-sticky'].scroll.top) ? 1 : ((b['oe-sticky'].scroll.top > a['oe-sticky'].scroll.top) ? -1 : 0);} );
                    break;
            }
        }

        return elements;
    };

    var getAddParameters = function(elements, type)
    {
        type = type !== 'right' && type !== 'bottom' && type !== 'left' ? 'top' : type;
        elements = sortElements(elements, type);
        var elementcount = elements.length;

        if(elementcount)
        {
            for(var outer = 0; outer < elementcount; outer++)
            {
                var curElement = elements[outer],
                    curData = curElement['oe-sticky'];

                for(var inner = 0; inner < outer; inner++) {
                    var tstElement = elements[inner],
                        tstData = tstElement['oe-sticky'],
                        collides = false,
                        add = 0;

                    if(type === 'left' || type === 'right') {
                        collides = curData.scroll.top < tstData.scroll.bottom && curData.scroll.bottom > tstData.scroll.top;
                        add = tstData.add[type] + (tstData.scroll.right - tstData.scroll.left);
                    }
                    else {
                        collides = curData.scroll.left < tstData.scroll.right && curData.scroll.right > tstData.scroll.left;
                        add = tstData.add[type] + (tstData.scroll.bottom - tstData.scroll.top);
                    }

                    if(collides) {
                        // console.log(curElement.className + " would collide with " + tstElement.className + " so let's add " + add + "px");
                        // console.log(tstData);
                        // console.log(tstData.add[type] + " + ( " + tstData.scroll.bottom + " - " + tstData.scroll.top + " )");
                        if(add > curData.add[type]) {
                            curData.add[type] = add;
                        }
                    }
                }
            }
        }

        return elements;
    };

    var setElementCoordinates = function() {
        var elements = getElements(),
            elementcount = elements.length;

        if(elementcount)
        {
            // measure scrollTop parameters
            elements = getAddParameters(elements);

            /*
            // measure scrollLeft parameters
            elements = getAddParameters(elements, 'left');

            // measure scrollBottom parameters
            elements = getAddParameters(elements, 'bottom');

            // measure scrollRight parameters
            elements = getAddParameters(elements, 'right');

            for(var i = 0; i < elementcount; i++)
            {
                console.log(elements[i]);
                console.log(elements[i]['oe-sticky'].scroll);
            }
            */
        }
    };

    var setElementStyles = function(element, fix, offset)
    {
        var wrapper = validateWrapper(element),
            data = element['oe-sticky'],
            options = getOptionsFor(element);

        if(fix === true)
        {
            var styles = [];

            if(!element.classList.contains(options.stickyClass))
            {
                styles.push('width:' + wrapper.offsetWidth + 'px');
                styles.push('height:' + wrapper.offsetHeight + 'px');
                element.setAttribute('style', styles.join(';'));

                styles.push('position:' + (options.usePositionFixed ? "fixed" : "absolute") );
                styles.push('left:' + (options.usePositionFixed ? data.offset.left + 'px' : 'auto') );
                wrapper.setAttribute('style', styles.join(';'));
            }

            if((!element.classList.contains(options.stickyClass) && options.usePositionFixed) || !options.usePositionFixed) {

                if(options.stickToBottom) {
                    if(options.usePositionFixed) {
                        wrapper.style.bottom = (data.add.bottom + options.paddingBottom) + 'px';
                    }
                    else {
                        wrapper.style.top = ((window.pageYOffset + window.innerHeight) - (data.scroll.bottom - data.add.bottom)) + 'px';
                    }
                }
                else {
                    if(options.usePositionFixed) {
                        wrapper.style.top = (data.add.top + options.paddingTop) + 'px';
                    }
                    else {
                        wrapper.style.top = ((window.pageYOffset - data.scroll.top) + data.add.top) + 'px';
                    }
                }
            }

            if(!element.classList.contains(options.stickyClass)) {
                element.classList.add(options.stickyClass);
            }

            if(parseInt(offset) < 0) {
                wrapper.style.marginTop = offset + 'px';
            }
        }
        else if(fix === false && element.classList.contains(options.stickyClass)) {
            // release the element!
            if(data.style.element)
            {
                element.setAttribute('style', data.style.element);
            }
            else
            {
                element.removeAttribute('style');
            }
            if(data.style.wrapper)
            {
                wrapper.setAttribute('style', data.style.wrapper);
            }
            else
            {
                wrapper.removeAttribute('style');
            }

            element.classList.remove(options.stickyClass);
        }
    };

    return Plugin;
})());
